module.exports = __webpack_public_path__ + "static/quartier_D-6d2bc22622ddd88c40ce47c52ae7a270.png";